import { TransactionStatus } from "@common/types/transaction";
import { TransactionView } from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { useMemo } from "react";
import { ACCRUAL_REVIEW_COLUMNS } from "./AccrualReviewDefaultView";

interface AccrualViewParams {
    id: string;
    name: string;
    entityIds: number[];
    filters: TransactionView["filters"];
}

const createAccrualView = ({
    id,
    name,
    entityIds,
    filters,
}: AccrualViewParams): NamedView<TransactionView> => ({
    id,
    name,
    type: ViewType.TRANSACTION,
    options: { bulkActions: true, selection: true },
    columns: ACCRUAL_REVIEW_COLUMNS,
    filters: { entityIds, statuses: [TransactionStatus.COMPLETED], ...filters },
});

export function useBuiltInAccrualReviewViews(
    accrualEntityIds: Set<number>,
): Array<NamedView<TransactionView>> {
    return useMemo(() => {
        if (accrualEntityIds.size === 0) {
            return [];
        }

        const entityIds = [...accrualEntityIds];
        return [
            createAccrualView({
                id: "in-review",
                name: "In review",
                entityIds,
                filters: { isNotAccrualReviewed: true },
            }),
            createAccrualView({
                id: "reviewed",
                name: "Reviewed",
                entityIds,
                filters: { isAccrualReviewed: true },
            }),
        ];
    }, [accrualEntityIds]);
}
